import React, { Component } from 'react';
import { Spring, animated } from 'react-spring';
import { isMobile, isTablet } from 'react-device-detect';
import PropTypes from 'prop-types';

import SpritesheetAnim from '../../components/SpritesheetAnim';
import AttackAnimation from '../../components/AttackAnimation';
import animalsConfigs from '../../constants/animalsConfigs';
import classAttackConfigs from '../../constants/classAttackConfigs';

import './styles.css';

const propTypes = {
  speedValues: PropTypes.oneOfType([PropTypes.object]),
  scrollPos: PropTypes.number,
  showAttackButton: PropTypes.func.isRequired,
  startAttack: PropTypes.bool.isRequired,
  handleStartAttack: PropTypes.func.isRequired,
  charClass: PropTypes.string.isRequired,
  shouldExplode: PropTypes.bool.isRequired,
  blockScroll: PropTypes.func.isRequired,
  isScrollBlocked: PropTypes.bool.isRequired,
};

const defaultProps = {
  speedValues: {},
  scrollPos: 0,
};

export default class Cave extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeAnimal: null,
      animals: animalsConfigs,
      hideAnimaInfo: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      scrollPos, startAttack, charClass, shouldExplode, blockScroll, isScrollBlocked,
    } = this.props;
    const { activeAnimal, animals } = this.state;
    let minStopVal = isMobile ? 15700 : 13700;
    const width = window.innerWidth;

    if (width > 1201 && width < 1500) {
      minStopVal = 14100;
    }

    if (width > 1000 && width < 1200) {
      minStopVal = 15000;
    }

    if (scrollPos > minStopVal && animals.length > 1 && !isScrollBlocked) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ showSign: true }, () => blockScroll(true));
    }

    if (scrollPos < 20000 && animals.length === 1 && isScrollBlocked) {
      blockScroll(false);
    }

    if (prevProps.scrollPos !== scrollPos && activeAnimal !== null) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ activeAnimal: null });
    }

    if (activeAnimal !== null && prevProps.startAttack !== startAttack) {
      if (charClass !== '' && startAttack) {
        this.handleClassAttack(charClass, activeAnimal, startAttack);
      }
    }

    if (
      prevProps.startAttack !== startAttack
      && !startAttack
      && shouldExplode
      && activeAnimal !== null
    ) {
      this.handleAnimalExplosion(activeAnimal);
    }
  }

  renderAnimals = () => {
    const { activeAnimal, animals, hideAnimaInfo } = this.state;

    return animals.map((animal, i) => {
      if (animal.id !== 4) {
        return (
          <div
            tabIndex={i}
            role="button"
            key={animal.id}
            className={`animals ${isMobile ? 'mobile' : ''} ${animal.className}`}
            onClick={() => this.handleAnimalInfo(animal.id, activeAnimal)}
            onKeyPress={() => this.handleAnimalInfo(animal.id, activeAnimal)}
          >
            <SpritesheetAnim
              ref={node => {
                this.sprite = node;
              }}
              styles={{ zIndex: '-1' }}
              spritePath={animal.spritePath}
              spriteConfigs={animal.spriteConfigs}
              spriteUpdated={animal.updated}
              loopAnim
            />
            {!hideAnimaInfo ? (
              <div
                className={`animal-info-container ${
                  activeAnimal && animal.id === activeAnimal.id ? 'active' : ''
                }`}
                style={{
                  backgroundImage: `url(${animal.info})`,
                  ...animal.style,
                }}
              />
            ) : null}
          </div>
        );
      }

      return false;
    });
  };

  handleClassAttack = (charClass, selectedAnimal, startAttack) => {
    const selectedCharacter = classAttackConfigs.filter(
      character => character.name === charClass,
    );

    this.setState({
      hideAnimaInfo: true,
      animationName: selectedCharacter[0].attackType,
      target: selectedAnimal.name,
      startAnimation: startAttack,
    });
  };

  handleAnimalExplosion = selectedAnimal => {
    this.setState({
      animationName: 'explosion',
      target: selectedAnimal.name,
      startAnimation: true,
    });
  };

  handleAnimalInfo = (id, activeAnimal) => {
    const { showAttackButton, startAttack, isScrollBlocked } = this.props;
    const selectedAnimal = animalsConfigs.filter(animal => animal.id === id);

    if (!startAttack || activeAnimal === null) {
      this.setState({
        activeAnimal: selectedAnimal[0],
        hideAnimaInfo: false,
      }, () => {
        if (activeAnimal === null && isScrollBlocked) {
          showAttackButton(true);
        }
      });
    }
  };

  handleStartAttack = () => {
    const { handleStartAttack, shouldExplode } = this.props;
    const { animals, activeAnimal } = this.state;

    if (shouldExplode) {
      const filterAnimals = animals.filter(
        animal => animal.id !== activeAnimal.id,
      );
      const totalAnimals = filterAnimals.length;
      const updateAnimals = filterAnimals.map(animal => {
        const obj = { ...animal };
        obj.updated = totalAnimals;
        return obj;
      });

      this.setState({
        startAnimation: false,
        activeAnimal: null,
        animals: updateAnimals,
      });
      return;
    }

    this.setState({ startAnimation: false }, () => handleStartAttack());
  };

  render() {
    const { speedValues, scrollPos } = this.props;
    const {
      animationName, target, startAnimation, showSign,
    } = this.state;

    return (
      <div className="scenario-3">
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.slow, 0, 0] }}
        >
          {({ xyz }) => (
            <>
              <animated.div
                className="layer-1"
                style={{
                  transform: xyz.to(
                    (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                  ),
                }}
              >
                <div className="inside-cave" />
                <div className="background" />
                <div className="ceiling-back" />
                <div className="left-door" />
                <div className="right-door" />
                <div className="out-left-back" />
                <div className="background-trans-sea" />
                <div className="sky" />
                <div className="out-right-back" />
              </animated.div>
              <animated.div
                className="layer-2"
                style={{
                  transform: xyz.to(
                    (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                  ),
                }}
              >
                <div className={`${isTablet ? 'tablet' : ''} ${isMobile ? 'mobile' : ''} out-left-front`} />
                <div className={`${isTablet ? 'tablet' : ''} ${isMobile ? 'mobile' : ''} out-right-front`} />
              </animated.div>
            </>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.slow, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-0"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="soft-hard-sign" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.normal, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-3"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="ceiling-mid" />
              {this.renderAnimals()}
              {startAnimation ? (
                <AttackAnimation
                  startAttack={startAnimation}
                  handleStartAttack={this.handleStartAttack}
                  animationName={animationName}
                  target={target}
                />
              ) : null}
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.fast, 0, 0] }}
        >
          {({ xyz }) => (
            <animated.div
              className="layer-4"
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className="ceiling-front" />
            </animated.div>
          )}
        </Spring>
        <Spring
          native
          from={{ xyz: [scrollPos, 0, 0] }}
          to={{ xyz: [speedValues.normal, 0, 0] }}
        >
          { ({ xyz }) => (
            <animated.div
              className={`${isMobile ? 'mobile' : ''} layer-5`}
              style={{
                transform: xyz.to(
                  (x, y, z) => `translate3d(${x}px, ${y}px, ${z}px)`,
                ),
              }}
            >
              <div className={`animals-sign ${showSign ? 'loaded' : ''}`} />
              <div className="rock" />
            </animated.div>
          )}
        </Spring>
      </div>
    );
  }
}

Cave.propTypes = propTypes;
Cave.defaultProps = defaultProps;
